/**
 * The one account internal developer surfaces are open to.
 *
 * This is a different axis from `Resource`/`Role` permissions, which describe
 * what a CUSTOMER may do inside the product. Some surfaces are not part of the
 * product at all — the gap-review tool shows every draft of the company beside
 * the raw pipeline records that produced it — and no customer role should reach
 * them however it is configured. A single shared team account is the whole
 * allowlist, so identity is the check.
 *
 * It lives here rather than in either app because both sides need the same
 * answer: the API to refuse the request, the UI to not show the door. The API
 * is the one that enforces it; the UI check only keeps the page out of sight.
 */
export const INTERNAL_TOOLS_EMAIL = 'team@intera-ai.io';
/**
 * Whether `email` is the internal account.
 *
 * Case- and whitespace-insensitive because the email arrives from a JWT claim
 * on one side and from a Clerk user object on the other, and neither promises a
 * normalised form. Missing means no: an absent claim must never pass.
 */
export function isInternalToolsEmail(email, allowedEmail = INTERNAL_TOOLS_EMAIL) {
    if (!email)
        return false;
    return email.trim().toLowerCase() === allowedEmail.trim().toLowerCase();
}
